export default {
    NONE: 'NONE',
    LOGO_POSITION: 'LOGO_POSITION',
    START_SHOW: 'START_SHOW',
    TAKE_MAZE_POSITION: 'TAKE_MAZE_POSITION',
    TAKE_SITE_POSITION: 'TAKE_SITE_POSITION',
};
